import React, { useState, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs'
import clsx from 'clsx'
import firebase from 'firebase/app';
import { createUseStyles } from 'react-jss'

import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

import ScheduleDate from './ScheduleDate';
import PunchClock from './PunchClock';
import { datesData, leaveTimeRangeCount, getWeekDay } from '../../modules/uitls';
import { tabletMedia } from '../../constants/index';
import ContextStore from '../../modules/context'
import useViewport from '../../hooks/windowSize';

dayjs.locale('en')

const hours = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11',
  '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
const minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
const drawerWidth = 240;
const useStyles = createUseStyles({
  scheduleTableContent: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    left: '270px',
    top: '60px',
    right: 0,
    backgroundColor: 'white',
  },
  scheduleTableColumn: {
    overflow: 'auto',
    position: 'absolute',
    maxHeight: 'calc(100vh - 64px - 60px)',
    width: 'calc(100vw - 270px - 150px)',
    [tabletMedia]: {
      display: 'none'
    }
  },
  scheduleTableHeader: {
    height: '60px',
    backgroundColor: '#f6f6f7',
    position: 'fixed',
    left: '160px + 270px',
    top: '64px',
    overflow: 'hidden',
    width: 'calc(100vw - 270px - 150px)',
    color: '#5f6578',
    fontSize: '16px',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'row',
    overflowY: 'hidden',
    paddingRight: '20px',
    [tabletMedia]: {
      display: 'none'
    }
  },
  dateTable: {
    position: 'relative',
    width: '116px',
    padding: '3px',
    flexShrink: 0,
    overflowY: 'scroll',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [tabletMedia]: {
      minHeight: '100px',
      padding: 0,
      backgroundColor: '#f6f6f7',
      width: '117px',
      borderLeft: '1px solid #828a99',
      borderRight: '1px solid #828a99',
      borderBottom: '1px solid #d9dce3',
    }
  },
  dateCloumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fieldManagerTable: {
    display: 'flex',
  },
  fieldManager: {
    position: 'relative',
    width: '116px',
    height: '40px',
    padding: '3px',
    flexShrink: 0,
    overflowY: 'scroll',
    borderTop: '1px solid #d9dce3',
    background: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom: '1px solid #828a99',
    [tabletMedia]: {
      display: 'none'
    }
  },
  fieldManagerSelect: {
    fontSize: '13px',
    height: '30px',
    fontWeight: '500',
    lineHeight: '2.29',
    textAlign: 'center',
    color: '#8c8c8d'
  },
  scheduleRow: {
    height: '100px',
    width: 'calc(100% - 430px)',
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    [tabletMedia]: {
      display: 'none'
    }
  },
  scheduleRowTable: {
    position: 'relative',
    width: '116px',
    padding: '3px',
    borderBottom: '1px solid #efeff4',
    flexShrink: 0,
    overflowY: 'scroll',
  },
  scheduleRowTableOffDay: {
    position: 'relative',
    width: '116px',
    padding: '3px',
    borderBottom: '1px solid #efeff4',
    flexShrink: 0,
    overflowY: 'scroll',
    backgroundColor: '#f6f7f8'
  },
  scheduleRowCloumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addComment: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 20px'
  },
  commentButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  addWeeklyLeave: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    padding: '20px 20px',
    fontSize: '15px',
  },
  leaveText: {
    display: 'flex',
    flexDirection: 'row',
  },
  leaveButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '30px',
  },
  punchClock: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '16px',
    padding: '20px 20px'
  },
  punchClockList: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  punchClockTime: {
    padding: '5px 0'
  },
  punchClockText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  punchClockButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '30px',
  },
  drawer: {
    width: `calc(100vw - (430px + ${drawerWidth}px))`
  },
  mobileDate: {
    display: 'flex',
    flexDirection: 'column',
    height: '449px',
    borderBottom: '1px solid #828a99',
    borderTop: '1px solid #828a99',
    marginTop: '105px',
    overflow: 'scroll',
    // [tabletMedia]: {
    //   maxHeight: '120px',
    // },
    // [moibleMedia]: {
    //   maxHeight: '380px'
    // }
  },
  mobileTable: {
    display: 'flex',
    flexDirection: 'row',
    [tabletMedia]: {
      width: '100%',
    }
  },
  mobileRow: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'center',
    width: '100%',
    borderRight: '1px solid #828a99',
    borderBottom: '1px solid #efeff6',
    padding: '6px 3px'
  },
  mobileRowOffDay: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'center',
    width: '100%',
    borderRight: '1px solid #828a99',
    borderBottom: '1px solid #efeff4',
    backgroundColor: '#f6f7f8',
    padding: '6px 0'
  },
  wrapper: {
    position: 'relative',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
    color: 'blue'
  },
  buttonDelProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -22,
    color: 'blue'
  },
});

const dayMapping = {
  'Mo': '一',
  'Tu': '二',
  'We': '三',
  'Th': '四',
  'Fr': '五',
  'Sa': '六',
  'Su': '日'
}

function ScheduleRows({
  currentUser,
  staffType,
  month,
  year,
  staffData,
  staffKey,
  workTimes,
  userRight,
  viewingStaff,
  isTablet,
  weeklyEarnedCount,
  punchClock,
  punchClockRevise,
  punchClockExceptions,
  weeklyLeaves,
  leaves,
  comments,
  onScrollRow
}) {
  const { formatMessage } = useIntl()
  const { drawerStatus } = useContext(ContextStore)
  const classes = useStyles();
  const { width, height } = useViewport()
  const [menuInfo, setMenuInfo] = useState(null)
  const [secondMenu, setSecondMenu] = useState(null)
  const [comment, setComment] = useState(null)
  const [commentId, setCommentId] = useState(null)
  const [weeklyLeaveId, setWeeklyLeaveId] = useState(null)
  const [punchClockData, setPunchClockData] = useState([])
  const [punchClockReviseOpen, setPunchClockReviseOpen] = useState(false)
  const [punchClockReviseData, setPunchClockReviseData] = useState({ hour: '09', minute: '00' })
  const [leaveData, setLeaveData] = useState({})
  const [timeError, setTimeError] = useState(false)
  const [weeklyError, setWeeklyError] = useState(false)
  const menuOpen = Boolean(menuInfo);
  const headerDatesRef = useRef()
  const dates = datesData(year, month)
  const dataMapping = {
    comment: comments,
    leave: leaves,
    weeklyLeave: weeklyLeaves,
    punchClockException: punchClockExceptions
  }
  const [loadingSaveComment, setLoadingSaveComment] = useState(false);
  const [loadingDelComment, setLoadingDelComment] = useState(false);
  const [loadingSaveWeekly, setLoadingSaveWeekly] = useState(false);
  const [loadingDelWeekly, setLoadingDelWeekly] = useState(false);

  let timeMap = {}

  function updateData(field, value, type) {
    if (type === 'leave') {
      let newValue = value
      let newData = { ...leaveData, [field.name]: newValue }

      if (secondMenu.weekly) {
        timeMap = { newData }
      }
      setLeaveData(newData)
    } else {
      let newValue = value
      let newData = { ...punchClockReviseData, [field.name]: newValue }

      setPunchClockReviseData(newData)
    }
  }

  function setCommentData(field, value) {
    let newValue = value
    let newData = { ...comment, [field.name]: newValue }

    setComment(newData)
  }

  const onEdit = (event, content, data, revise) => {
    if (content === 'editComment') {
      setComment(event)
      setCommentId(event.id)
    } else if (content === 'editWeeklyLeave') {
      const starTime = String(event.startTime).split(':')
      const endTime = String(event.endTime).split(':')
      const newData = {
        startHour: starTime[0],
        startMin: starTime[1],
        endHour: endTime[0],
        endMin: endTime[1]
      }
      setLeaveData(newData)
      setWeeklyLeaveId(event.id)
    } else {
      let newEvent = new PunchClock(dayjs(data.date), event, revise ? revise : [])
      setPunchClockData(newEvent.list)
    }

    setSecondMenu({ [content]: true })
  }

  async function deleteComment() {
    setLoadingDelComment(true)

    try {
      await firebase.firestore().collection('comments').doc(`${commentId}`).delete();
      setLoadingDelComment(false)
      handleClose();
    } catch (ex) {
      console.log(ex)
    }
  }

  async function deleteWeeklyLeave() {
    setLoadingDelWeekly(true)

    try {
      await firebase.firestore().collection('weeklyLeaves').doc(`${weeklyLeaveId}`).delete();
      setLoadingDelWeekly(false)
      handleClose();
    } catch (ex) {
      console.log(ex)
    }
  }

  async function saveComment() {
    setLoadingSaveComment(true)
    if (secondMenu.editComment) {
      const updateData = {
        ...comment,
        updatedAt: new Date(),
        updatedBy: currentUser.key,
      }
      try {
        await firebase.firestore().collection('comments').doc(`${commentId}`).update(updateData)
        setLoadingSaveComment(false)
        handleClose();
      } catch (ex) {
        setLoadingSaveComment(false)
        console.log(ex)
      }
    } else if (secondMenu.comment) {
      const newData = {
        comment: comment.comment,
        createdAt: new Date(),
        createdBy: currentUser.key,
        date: dayjs(menuInfo.date).format('YYYY-MM-DD'),
        staff: menuInfo.staff.id
      }

      try {
        await firebase.firestore().collection('comments').doc().set(newData)
        setLoadingSaveComment(false)
        handleClose();
      } catch (ex) {
        setLoadingSaveComment(false)
        console.log(ex)
      }
    } else {
      setLoadingSaveComment(false)
      handleClose();
    }
  }

  async function saveWeeklyLeave() {
    setLoadingSaveWeekly(true)
    const workTime = workTimes[getWeekDay(dayjs(menuInfo.date))] || '00:00'
    if (['reborn', 'lexcellence'].includes(process.env.BRANCH_ENV)) {
      if (`${leaveData.endHour}:${leaveData.endMin}` > workTime.endTime) {
        setTimeError(true)
        setLoadingSaveWeekly(false)
        return false
      }
    } else {
      if (`${leaveData.startHour}:${leaveData.startMin}` < workTime.startTime || `${leaveData.endHour}:${leaveData.endMin}` > workTime.endTime) {
        setTimeError(true)
        setLoadingSaveWeekly(false)
        return false
      }
    }

    if (dayjs(`${dayjs(menuInfo.date).format('YYYY-MM-DD')} ${leaveData.startHour}:${leaveData.startMin}`, 'YYYY-MM-DD HH:mm')
      .isAfter(dayjs(`${dayjs(menuInfo.date).format('YYYY-MM-DD')} ${leaveData.endHour}:${leaveData.endMin}`, 'YYYY-MM-DD HH:mm'))) {
      setTimeError(true)
      setLoadingSaveWeekly(false)
      return false
    }

    const pce = punchClockExceptions.reduce((acc, cur) => {
      if (cur.date === dayjs(menuInfo.date).format('YYYY-MM-DD')) {
        acc[cur.date] = { ...cur }
      }

      return acc
    }, {})

    const staffWeekly = weeklyLeaves.filter(s => s.staff === menuInfo.staff.id)
    const weeklyTotal = weeklyEarnedCount(menuInfo.staff.id, true)
    const newLeaveData = {
      startDate: menuInfo.date,
      endDate: menuInfo.date,
      startHour: leaveData.startHour,
      startMinute: leaveData.startMin,
      endHour: leaveData.endHour,
      endMinute: leaveData.endMin,
      leaveType: 'weekly_leave'
    }

    const currentTime = leaveTimeRangeCount(newLeaveData, staffType, workTimes, pce)
    const currentHours = currentTime ? (currentTime.day * 8) + currentTime.hour : 0

    let hours = 0
    for (const data of staffWeekly) {
      let newData = {
        startDate: data.date,
        endDate: data.date,
        startHour: data.startTime.split(':')[0],
        startMinute: data.startTime.split(':')[1],
        endHour: data.endTime.split(':')[0],
        endMinute: data.endTime.split(':')[1],
      }
      if (secondMenu.editWeeklyLeave) {
        if (weeklyLeaveId === data.id) {
          newData = {
            ...newData,
            startHour: leaveData.startHour,
            startMinute: leaveData.startMin,
            endHour: leaveData.endHour,
            endMinute: leaveData.endMin,
          }
        }
      }

      const leaveOfTime = leaveTimeRangeCount(newData, staffType, workTimes, pce)

      if (leaveOfTime) {
        hours += (leaveOfTime.day * 8) + leaveOfTime.hour
      }
    }

    if (secondMenu.editWeeklyLeave) {
      if (hours > weeklyTotal) {
        setWeeklyError(true)
        setLoadingSaveWeekly(false)
        return false
      }
      const newData = {
        startTime: `${leaveData.startHour}:${leaveData.startMin}`,
        endTime: `${leaveData.endHour}:${leaveData.endMin}`,
        updatedAt: new Date(),
        updatedBy: currentUser.key,
      }

      try {
        await firebase.firestore().collection('weeklyLeaves').doc(`${weeklyLeaveId}`).update(newData)
        setLoadingSaveWeekly(false)
        setWeeklyError(false)
        handleClose();
      } catch (ex) {
        setLoadingSaveWeekly(false)
        setWeeklyError(false)
        console.log(ex)
      }
    } else {
      if ((currentHours + hours) > weeklyTotal) {
        setWeeklyError(true)
        setLoadingSaveWeekly(false)
        return false
      }

      const newData = {
        startTime: `${timeMap.startHour || leaveData.startHour}:${timeMap.startMin || leaveData.startMin}`,
        endTime: `${timeMap.endHour || leaveData.endHour}:${timeMap.endMin || leaveData.endMin}`,
        date: dayjs(menuInfo.date).format('YYYY-MM-DD'),
        createdAt: new Date(),
        createdBy: currentUser.key,
        staff: menuInfo.staff.id
      }

      try {
        await firebase.firestore().collection('weeklyLeaves').doc().set(newData)
        setLoadingSaveWeekly(false)
        setWeeklyError(false)
        handleClose();
      } catch (ex) {
        setLoadingSaveWeekly(false)
        setWeeklyError(false)
        console.log(ex)
      }
    }
  }

  function openAddMenu() {
    if (secondMenu.comment || secondMenu.editComment) {
      return (
        <div className={classes.addComment}>
          {secondMenu.comment ? formatMessage({ id: 'schedule.anchor.add_comment' }) : formatMessage({ id: 'schedule.anchor.edit_comment' })}
          {secondMenu.editComment ? <TextField
            margin="normal"
            multiline
            variant="outlined"
            fullWidth
            size="medium"
            rows="2"
            value={comment.comment}
            onChange={(e) => setCommentData({ name: 'comment' }, e.target.value)}
          /> : <TextField
            margin="normal"
            multiline
            variant="outlined"
            fullWidth
            size="medium"
            rows="2"
            onChange={(e) => setCommentData({ name: 'comment' }, e.target.value)}
          />}
          <div className={classes.commentButton}>
            {secondMenu.editComment && <div className={classes.wrapper}>
              <Button style={{ marginRight: '20px' }} variant="contained" onClick={() => deleteComment()} color="secondary" disabled={loadingSaveComment || loadingDelComment}>
                {formatMessage({ id: 'button.delete' })}
              </Button>
              {loadingDelComment && <CircularProgress size={24} className={classes.buttonDelProgress} />}
            </div>}
            <Button style={{ marginRight: '10px' }} variant="contained" onClick={handleClose} color="inherit">
              {formatMessage({ id: 'button.close' })}
            </Button>
            <div className={classes.wrapper}>
              <Button variant="contained" onClick={() => saveComment()} color="primary" disabled={loadingSaveComment || loadingDelComment}>
                {secondMenu.editComment ? formatMessage({ id: 'button.save' }) : formatMessage({ id: 'button.add' })}
              </Button>
              {loadingSaveComment && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
          </div>
        </div>
      );
    } else if (secondMenu.weekly || secondMenu.editWeeklyLeave) {
      return (
        <div className={classes.addWeeklyLeave}>
          {secondMenu.weekly ? formatMessage({ id: 'schedule.anchor.add_weekly_leave' }) : formatMessage({ id: 'schedule.anchor.edit_weekly_leave' })}
          <div>{formatMessage({ id: 'schedule.anchor.start' })}</div>
          <div className={classes.leaveText}>
            <TextField
              margin="normal"
              multiline
              variant="outlined"
              size="small"
              select
              style={{ marginRight: '10px' }}
              onChange={(e) => updateData({ name: 'startHour' }, e.target.value, 'leave')}
              value={leaveData.startHour}
            >
              {hours.map(hour => {
                return <MenuItem style={{ padding: '0px 0 0 5px' }} key={hour} value={hour}>{hour}</MenuItem>
              })}
            </TextField>
            <TextField
              margin="normal"
              multiline
              variant="outlined"
              size="small"
              select
              onChange={(e) => updateData({ name: 'startMin' }, e.target.value, 'leave')}
              value={leaveData.startMin}
            >
              {minutes.map(minute => {
                return <MenuItem style={{ padding: '0px 0 0 5px' }} key={minute} value={minute}>{minute}</MenuItem>
              })}
            </TextField>
          </div>

          <div>{formatMessage({ id: 'schedule.anchor.end' })}</div>
          <div className={classes.leaveText}>
            <TextField
              margin="normal"
              multiline
              variant="outlined"
              size="small"
              select
              style={{ marginRight: '10px' }}
              onChange={(e) => updateData({ name: 'endHour' }, e.target.value, 'leave')}
              value={leaveData.endHour}
            >
              {hours.map(hour => {
                return <MenuItem style={{ padding: '0px 0 0 5px' }} key={hour} value={hour}>{hour}</MenuItem>
              })}
            </TextField>
            <TextField
              margin="normal"
              multiline
              variant="outlined"
              size="small"
              select
              onChange={(e) => updateData({ name: 'endMin' }, e.target.value, 'leave')}
              value={leaveData.endMin}
            >
              {minutes.map(minute => {
                return <MenuItem style={{ padding: '0px 0 0 5px' }} key={minute} value={minute}>{minute}</MenuItem>
              })}
            </TextField>
          </div>
          {timeError && <div style={{ color: 'red' }}>{formatMessage({ id: 'form.time.formatError' })}</div>}
          {weeklyError && <div style={{ color: 'red' }}>{formatMessage({ id: 'form.time.weeklyLeave' })}</div>}
          <div className={classes.leaveButton}>
            {secondMenu.editWeeklyLeave && <div className={classes.wrapper}>
              <Button style={{ marginRight: '20px' }} variant="contained" onClick={() => deleteWeeklyLeave()} color="secondary" disabled={loadingSaveWeekly || loadingDelWeekly}>
                {formatMessage({ id: 'button.delete' })}
              </Button>
              {loadingDelWeekly && <CircularProgress size={24} className={classes.buttonDelProgress} />}
            </div>}
            <Button style={{ marginRight: '10px' }} variant="contained" onClick={handleClose} color="inherit">
              {formatMessage({ id: 'button.close' })}
            </Button>
            <div className={classes.wrapper}>
              <Button variant="contained" onClick={() => saveWeeklyLeave()} color="primary" disabled={loadingSaveWeekly || loadingDelWeekly}>
                {secondMenu.editWeeklyLeave ? formatMessage({ id: 'button.save' }) : formatMessage({ id: 'button.add' })}
              </Button>
              {loadingSaveWeekly && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className={classes.punchClock}>
          {formatMessage({ id: 'schedule.anchor.punchClock' })}
          {punchClockData.map(pc => {
            return <div className={classes.punchClockList} key={pc.time}>
              <div style={{ color: pc.revised ? 'blue' : '' }} className={classes.punchClockTime}>{pc.time}</div>
            </div>
          })}
          {punchClockReviseOpen && <div className={classes.punchClockText}>
            <TextField
              margin="normal"
              multiline
              variant="outlined"
              size="small"
              select
              style={{ marginRight: '10px' }}
              onChange={(e) => updateData({ name: 'hour' }, e.target.value, 'punchCLock')}
              value={punchClockReviseData.hour}
            >
              {hours.map(hour => {
                return <MenuItem style={{ padding: '0px 0 0 5px' }} key={hour} value={hour}>{hour}</MenuItem>
              })}
            </TextField>
            <TextField
              margin="normal"
              multiline
              variant="outlined"
              size="small"
              select
              onChange={(e) => updateData({ name: 'minute' }, e.target.value, 'punchCLock')}
              value={punchClockReviseData.minute}
            >
              {minutes.map(minute => {
                return <MenuItem style={{ padding: '0px 0 0 5px' }} key={minute} value={minute}>{minute}</MenuItem>
              })}
            </TextField>
          </div>}
          <div className={classes.punchClockButton}>
            <Button style={{ marginRight: '10px' }} variant="contained" onClick={handleClose} color="inherit">
              {formatMessage({ id: 'button.close' })}
            </Button>
          </div>
        </div>
      );
    }
  }

  function onContentScroll({ target: { scrollLeft, scrollTop } }) {
    requestAnimationFrame(() => {
      headerDatesRef.current.scrollLeft = scrollLeft
      onScrollRow(scrollTop)
    });
  }

  function openSecondMenu(event) {
    setSecondMenu({ [event]: true })

    if (event === 'weekly') {
      const workTime = workTimes[getWeekDay(dayjs(menuInfo.date))] || { startTime: '09:00', endTime: '18:00' }
      const startT = workTime.startTime.split(':')
      const endT = workTime.endTime.split(':')
      timeMap.startHour = startT[0]
      timeMap.startMin = startT[1]
      timeMap.endHour = endT[0]
      timeMap.endMin = endT[1]

      setLeaveData(timeMap)
    }
  }

  const handleMenu = (event, date, staff) => {
    const exception = punchClockExceptions.filter(p => p.date === dayjs(date).format('YYYY-MM-DD') && p.type === 'on')
    if (dayjs(date).day() !== 0 || exception.length > 0) {
      if (['nurse', 'customerService', 'salesRep'].includes(staffType) || secondMenu) {
        if (!userRight['schedule-edit'] && secondMenu) {
          setMenuInfo({ date, staff, anchor: event.currentTarget })
        } else if (userRight['schedule-edit']) {
          setMenuInfo({ date, staff, anchor: event.currentTarget })
        }
      }
    } else {
      setMenuInfo(null)
    }
  };

  const handleClose = () => {
    setMenuInfo(null);
    setSecondMenu(null);
    setCommentId(null);
    setWeeklyLeaveId(null);
    setComment(null);
    setPunchClockReviseOpen(false);
    setTimeError(false)
    setWeeklyError(false)
    setPunchClockReviseData({
      hour: '09',
      minute: '00'
    })
    setLeaveData({
      startHour: '00',
      startMin: '00',
      endHour: '00',
      endMin: '00'
    })
  };

  if (isTablet && viewingStaff) {
    return (
      <div className={classes.mobileDate} style={{ maxHeight: `calc(${height}px - 290px` }}>
        {menuInfo && <Menu
          id="menu-appbar"
          anchorEl={menuInfo.anchor}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: isTablet ? 'center' : 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: isTablet ? 'center' : 'top',
            horizontal: 'right',
          }}
          open={menuOpen}
          onClose={handleClose}
        >
          {!secondMenu ? <span>
            <MenuItem onClick={() => openSecondMenu('comment')}>
              {formatMessage({ id: 'schedule.anchor.add_comment' })}
            </MenuItem>
            <MenuItem onClick={() => openSecondMenu('weekly')}>
              {formatMessage({ id: 'schedule.anchor.add_weekly_leave' })}
            </MenuItem>
          </span> : openAddMenu()}
        </Menu>}
        {dates.map(date => {
          let isDayOff = false;
          const weekday = dayjs(date).day()
          if (['nurse', 'customerService', 'salesRep'].includes(staffType) && process.env.BRANCH_ENV !== 'santea') {
            isDayOff = weekday === 0;
          } else {
            isDayOff = (weekday === 6 || weekday === 0);
          }
          return <div className={classes.mobileTable} style={{ maxWidth: width }} key={date}>
            <div className={classes.dateTable}>
              <div className={classes.dateCloumn}>
                <div>{`${date.format('M/D')} (${dayMapping[date.format('dd')]})`}</div>
              </div>
            </div>
            <div className={!isDayOff ? classes.mobileRow : classes.mobileRowOffDay} onClick={(e) => handleMenu(e, date, staffData[viewingStaff])}>
              <div className={classes.scheduleRowCloumn}>
                <div>
                  <ScheduleDate
                    date={date}
                    staff={staffData[viewingStaff]}
                    staffId={viewingStaff}
                    dataMapping={dataMapping}
                    onSubmit={onEdit}
                    punchClock={punchClock}
                    punchClockRevise={punchClockRevise}
                    workTime={workTimes}
                    isDayOff={isDayOff}
                    userRight={userRight}
                    staffType={staffType}
                  />
                </div>
              </div>
            </div>
          </div>
        })}
      </div>
    );
  }

  const dateRows = staffKey.map((key, idx) => {
    return <div key={idx}>
      <div className={classes.scheduleRow}>
        {dates.map(date => {
          let isDayOff = false;
          const weekday = dayjs(date).day()
          const ex = punchClockExceptions.reduce((acc, cur) => {
            if (cur.date === dayjs(date).format('YYYY-MM-DD') && cur.department.includes(staffType)) {
              acc = cur.type
            }
            return acc
          }, '')

          if (['nurse', 'customerService', 'salesRep'].includes(staffType) && !['santea', 'lexcellence'].includes(process.env.BRANCH_ENV)) {
            isDayOff = (weekday === 0);
            if (ex) {
              isDayOff = ex === 'off' ? true : false
            }
          } else {
            isDayOff = (weekday === 6 || weekday === 0);
            if (ex) {
              isDayOff = ex === 'off' ? true : false
            }
          }

          return (
            <div key={date} className={!isDayOff ? classes.scheduleRowTable : classes.scheduleRowTableOffDay} onClick={(e) => handleMenu(e, date, staffData[key])}>
              <div className={classes.scheduleRowCloumn}>
                <div>
                  <ScheduleDate
                    date={date}
                    staff={staffData[key]}
                    staffId={key}
                    dataMapping={dataMapping}
                    onSubmit={onEdit}
                    punchClock={punchClock}
                    punchClockRevise={punchClockRevise}
                    workTime={workTimes}
                    isDayOff={isDayOff}
                    userRight={userRight}
                    staffType={staffType}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  })

  return (
    <div className={classes.scheduleTableContent}>
      <div className={clsx(classes.scheduleTableColumn, { [classes.drawer]: drawerStatus.display !== 'none' })} onScroll={onContentScroll}>
        {menuInfo && <Menu
          id="menu-appbar"
          anchorEl={menuInfo.anchor}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={menuOpen}
          onClose={handleClose}
        >
          {!secondMenu ? <span>
            <MenuItem onClick={() => openSecondMenu('comment')}>
              {formatMessage({ id: 'schedule.anchor.add_comment' })}
            </MenuItem>
            <MenuItem onClick={() => openSecondMenu('weekly')}>
              {formatMessage({ id: 'schedule.anchor.add_weekly_leave' })}
            </MenuItem>
          </span> : openAddMenu()}
        </Menu>}
        <div className={clsx(classes.scheduleTableHeader, { [classes.drawer]: drawerStatus.display !== 'none' })} style={{ borderBottom: '1px solid #828a99' }} ref={headerDatesRef}>
          {dates.map(date => {
            return <div key={date} className={classes.dateTable}>
              <div className={classes.dateCloumn}>
                <div>{`${date.format('M/D')} (${dayMapping[date.format('dd')]})`}</div>
              </div>
            </div>
          })}
        </div>
        {dateRows}
      </div>
    </div>
  );
}


ScheduleRows.propTypes = {
  currentUser: PropTypes.shape({
    key: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    department: PropTypes.string.isRequired,
    isManagement: PropTypes.bool.isRequired,
    active: PropTypes.bool.isRequired,
  }),
  staffType: PropTypes.string.isRequired,
  month: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
  staffData: PropTypes.object,
  staffKey: PropTypes.arrayOf(PropTypes.string.isRequired),
  workTimes: PropTypes.object.isRequired,
  userRight: PropTypes.object.isRequired,
  viewingStaff: PropTypes.string,
  isTablet: PropTypes.bool,
  weeklyEarnedCount: PropTypes.func.isRequired,
  punchClock: PropTypes.object.isRequired,
  punchClockRevise: PropTypes.object.isRequired,
  punchClockExceptions: PropTypes.array.isRequired,
  weeklyLeaves: PropTypes.arrayOf(PropTypes.object.isRequired),
  leaves: PropTypes.arrayOf(PropTypes.object.isRequired),
  comments: PropTypes.arrayOf(PropTypes.object.isRequired),
  onScrollRow: PropTypes.func.isRequired
};

export default ScheduleRows;

